module.exports = __webpack_public_path__ + "img/world-map-500.970d091.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/world-map-500.png
// module id = ./assets/img/world-map-500.png
// module chunks = 1 22 26 27 29 30